import * as React from 'react';
import { useCallback } from 'react';
import {
    SaveButton,
    Toolbar,
    useCreate,
    useRedirect,
    useNotify,
    crudCreate,
} from 'react-admin';

// A custom action creator which modifies the values before calling the default crudCreate action creator
// const saveWithOrderId = (values, basePath, redirectTo, orderId) =>
    // crudCreate('sap_sdo_for_orders', { ...values, sap_digital_order_id: orderId }, basePath, redirectTo);

const  SaveWithNoteButton = props => {
    const { saveWithOrderId, orderId } = props;
    const [create] = useCreate('sap_sdo_for_orders');
    const redirectTo = useRedirect();
    const notify = useNotify();
    const { basePath } = props;
    console.log('xxxxxxx', props);
    const handleSave = useCallback(
        (values, redirect) => {
            create(
                // saveWithOrderId(values, basePath, `/sap_digital_orders/${orderId}/show/2`, orderId),
                {
                    payload: {
                        ...values,
                        data: { ...values, sap_digital_order_id: orderId },
                    },
                },
                {
                    onSuccess: ({ data: newRecord }) => {
                        notify('Created', 'info');
                        redirectTo(...values, redirect, basePath, redirectTo);
                    },
                }
            );
        },
        [create, notify, redirectTo, basePath]
    );
    // set onSave props instead of handleSubmitWithRedirect
    return <SaveButton {...props} onSuccess={handleSave} />;
}

export default SaveWithNoteButton